/// <reference path="appbase.ts" />


namespace TerminalApp {
    class LogElement {
        constructor(message: string) {
            this.time = Date.now();
            this.event = message;
        }
        time: number;
        event: string;
    }

    export class DeviceLog extends AppBase {
        bound = false;
        output = document.getElementById("adl_output");
        logs: LogElement[] = [];

        static log(message: string) {
            (GetApp("app_device_log") as DeviceLog).log(message);
        }

        static instance: DeviceLog;
        constructor() {
            super("app_device_log");
            DeviceLog.instance = this;

            var log = localStorage.getItem("device_log");
            if (log) this.logs = JSON.parse(log);

            window.addEventListener("beforeunload", (evt) => {
                this.trim();
                localStorage.setItem("device_log", JSON.stringify(this.logs));
            });
        }

        log(message: string) {
            this.logs.push(new LogElement(message));
            if (this.log.length > 400) {
                this.trim();
            }
        }

        trim() {
            var remove = this.log.length - 200;
            if (remove > 0) this.logs = this.logs.slice(remove);
        }


        padTo2Digits(num: number) {
            return num.toString().padStart(2, '0');
        }

        formatDate(date: Date) {
            return (
                [
                    date.getFullYear(),
                    this.padTo2Digits(date.getMonth() + 1),
                    this.padTo2Digits(date.getDate()),
                ].join('-') +
                ' ' +
                [
                    this.padTo2Digits(date.getHours()),
                    this.padTo2Digits(date.getMinutes()),
                    this.padTo2Digits(date.getSeconds()),
                ].join(':')
            );
        }

        async onOpen() {
            this.output.innerHTML = "";
            var out = this.output.appendChild(document.createElement("ul"));
            for (let i = this.logs.length - 1; i >= 0; i--) {
                let elm = out.appendChild(document.createElement("li"));
                var date = this.formatDate(new Date(this.logs[i].time));
                elm.innerHTML = `<span class='time'>${date}</span> ${this.logs[i].event}`;
            }
        }

        async onClose() {
            this.output.innerHTML = "";
        }
    }



    RegisterApp("app_device_log", DeviceLog);
}